<template>
  <div>
    <b-card no-body class="card-transparent-background">
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help" v-if="is_company == 1">
          Company Registration
        </b-card-title>
        <b-card-title class="card-title-form-steps-garden-help" v-else>
          Contractor Registration
        </b-card-title>
        <b-card-sub-title class="card-subtitle-form-steps-garden-help">
          Please provide us with your details to start working now
        </b-card-sub-title>
      </b-card-header>
      <b-card-body class="p-0">
        <b-card no-body v-if="is_company == 1">
          <b-card-body class="px-2 pt-3 pb-2">
            <div class="container">
              <InputFile label="Company Logo" button_text="Upload file" :multiple="false" :accept="'image/*'"
                :selectedfile_prop.sync="_company_logo" />
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-body class="px-2 pt-3 pb-2">
            <div class="container">
              <InputFile label="Images" button_text="Upload file" :multiple="true" :accept="'image/*'"
                :selectedfile_prop.sync="_images" />
            </div>
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-body class="px-2 pt-3 pb-2">
            <div class="container">
              <InputFile label="Job Reference " button_text="Upload file" :multiple="false"
                :accept="'image/*,video/*,.pdf,.doc,.docx'" :selectedfile_prop.sync="_job_reference" />
            </div>
          </b-card-body>
        </b-card>
        <!-- <b-card no-body>
          <b-card-body class="px-2 py-4">
            <div class="container">
              <b-row>
                <b-col>
                  <p class="form-label-garden-help my-2 float-left w-auto">
                    Connect with
                    <img src="@/assets/images/stripe.png" width="70px" style="margin-top: -3px" />
                  </p>

                  <b-button variant="garden-help-primary-light" class="btn-bumblebee btn-garden-help float-right">
                    Connect
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card> -->

        <p class="error_validation_message_p_gardenhelp" v-if="invalid_term_conditions">
          You must agree to the terms and conditions to proceed
        </p>
        <b-form-checkbox class="
            form-group-checkbox-group form-group-check-garden-help
            checkbox-terms-garden-help
          " v-model="_term_conditions" name="term_conditions" value="1" unchecked-value="0">
          I have read and agreed to the <a href="https://garden-help.tech/privacy" target="_blank">Terms & conditions</a>
        </b-form-checkbox>
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import InputFile from "@/components/Inputs/InputFile.vue";

export default {
  name: "FilesInputView",
  components: { InputFile },
  props: ["type", "is_company", "company_logo", "images", "job_reference", "invalid_term_conditions"],

  data() {
    return {};
  },
  mounted() { },

  computed: {
    _company_logo: {
      get() {
        return this.company_logo;
      },
      set(value) {
        this.$emit("update:company_logo", value);
      },
    },
    _images: {
      get() {
        return this.images;
      },
      set(value) {
        this.$emit("update:images", value);
      },
    },
    _job_reference: {
      get() {
        return this.job_reference;
      },
      set(value) {
        this.$emit("update:job_reference", value);
      },
    },
    _term_conditions: {
      get() {
        return this.term_conditions;
      },
      set(value) {
        this.$emit("update:term_conditions", value);
      },
    },
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/FilesInputView.vue